import _styled from "@emotion/styled-base";

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

import CopyIcon from '@atlaskit/icon/glyph/copy';
import Tooltip from '@atlaskit/tooltip';
import { log } from '@atlassian/mpac-utils';
import clipboard from 'clipboard-js';
import React, { useState } from 'react';

const Cursor = _styled("div", {
  target: "exflw80",
  label: "Cursor"
})(process.env.NODE_ENV === "production" ? {
  name: "1rl84i6",
  styles: "cursor:pointer;height:24px;"
} : {
  name: "1rl84i6",
  styles: "cursor:pointer;height:24px;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9wcmltaXRpdmVzL1RleHRDbGlwcGVyL1RleHRDbGlwcGVyLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQVN5QiIsImZpbGUiOiIuLi8uLi8uLi9zcmMvcHJpbWl0aXZlcy9UZXh0Q2xpcHBlci9UZXh0Q2xpcHBlci5qcyIsInNvdXJjZXNDb250ZW50IjpbIi8vIEBmbG93XG5cbmltcG9ydCBDb3B5SWNvbiBmcm9tICdAYXRsYXNraXQvaWNvbi9nbHlwaC9jb3B5JztcbmltcG9ydCBUb29sdGlwIGZyb20gJ0BhdGxhc2tpdC90b29sdGlwJztcbmltcG9ydCB7IGxvZyB9IGZyb20gJ0BhdGxhc3NpYW4vbXBhYy11dGlscyc7XG5pbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XG5pbXBvcnQgY2xpcGJvYXJkIGZyb20gJ2NsaXBib2FyZC1qcyc7XG5pbXBvcnQgUmVhY3QsIHsgdXNlU3RhdGUgfSBmcm9tICdyZWFjdCc7XG5cbmNvbnN0IEN1cnNvciA9IHN0eWxlZC5kaXZgXG4gIGN1cnNvcjogcG9pbnRlcjtcbiAgaGVpZ2h0OiAyNHB4O1xuYDtcblxudHlwZSBQcm9wcyA9IHtcbiAgdGV4dDogP3N0cmluZyxcbn07XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIFRleHRDbGlwcGVyKHsgdGV4dCB9OiBQcm9wcykge1xuICBjb25zdCBbdG9vbHRpcENvbnRlbnQsIHNldFRvb2x0aXBDb250ZW50XSA9IHVzZVN0YXRlKCdDb3B5IHRvIGNsaXBib2FyZCcpO1xuXG4gIGNvbnN0IGhhbmRsZUNvcHlUZXh0ID0gKGNvcHlUZXh0OiA/c3RyaW5nKSA9PiB7XG4gICAgY2xpcGJvYXJkXG4gICAgICAuY29weShjb3B5VGV4dClcbiAgICAgIC50aGVuKCgpID0+IHtcbiAgICAgICAgc2V0VG9vbHRpcENvbnRlbnQoJ0NvcGllZCcpO1xuICAgICAgICBzZXRUaW1lb3V0KCgpID0+IHNldFRvb2x0aXBDb250ZW50KCdDb3B5IHRvIGNsaXBib2FyZCcpLCAxNTAwKTtcbiAgICAgIH0pXG4gICAgICAuY2F0Y2goZXJyb3IgPT4ge1xuICAgICAgICBsb2cuZXJyb3IoJ1RleHRDbGlwcGVyJywgYEZhaWxlZCB0byBjb3B5IHRoZSB0ZXh0YCwge1xuICAgICAgICAgIGVycjogZXJyb3IsXG4gICAgICAgIH0pO1xuICAgICAgICBzZXRUb29sdGlwQ29udGVudCgnRmFpbGVkLCBjb3B5IGFnYWluJyk7XG4gICAgICAgIHNldFRpbWVvdXQoKCkgPT4gc2V0VG9vbHRpcENvbnRlbnQoJ0NvcHkgdG8gY2xpcGJvYXJkJyksIDE1MDApO1xuICAgICAgfSk7XG4gIH07XG5cbiAgcmV0dXJuIChcbiAgICA8VG9vbHRpcCBjb250ZW50PXt0b29sdGlwQ29udGVudH0gcG9zaXRpb249XCJ0b3BcIj5cbiAgICAgIDxDdXJzb3I+XG4gICAgICAgIDxzcGFuIG9uQ2xpY2s9eygpID0+IGhhbmRsZUNvcHlUZXh0KHRleHQpfT5cbiAgICAgICAgICA8Q29weUljb24gLz5cbiAgICAgICAgPC9zcGFuPlxuICAgICAgPC9DdXJzb3I+XG4gICAgPC9Ub29sdGlwPlxuICApO1xufVxuIl19 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});

export default function TextClipper({
  text
}) {
  const [tooltipContent, setTooltipContent] = useState('Copy to clipboard');

  const handleCopyText = copyText => {
    clipboard.copy(copyText).then(() => {
      setTooltipContent('Copied');
      setTimeout(() => setTooltipContent('Copy to clipboard'), 1500);
    }).catch(error => {
      log.error('TextClipper', "Failed to copy the text", {
        err: error
      });
      setTooltipContent('Failed, copy again');
      setTimeout(() => setTooltipContent('Copy to clipboard'), 1500);
    });
  };

  return /*#__PURE__*/React.createElement(Tooltip, {
    content: tooltipContent,
    position: "top"
  }, /*#__PURE__*/React.createElement(Cursor, null, /*#__PURE__*/React.createElement("span", {
    onClick: () => handleCopyText(text)
  }, /*#__PURE__*/React.createElement(CopyIcon, null))));
}